// extracted by mini-css-extract-plugin
export default {"dealerGroupDetailContainer":"_dealer-group-detail_dealerGroupDetailContainer__Er02E"};